var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4966_14388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.5C0.5 12.5 2.5 10.5 5.63636 10.5C6 10.5 8 10.5 8 10.5M12.5 9.5V12.5M12.5 12.5H15.5M12.5 12.5V15.5M12.5 12.5H9.5M6.5 8.5C4.28255 8.5 2.5 6.70914 2.5 4.5C2.5 2.29086 4.28781 0.5 6.5 0.5C8.73305 0.5 10.5 2.24449 10.5 4.52391C10.5 6.76633 8.71745 8.5 6.5 8.5Z",
    stroke: "#67726D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4966_14388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.2e8689fe7c496011707f1d037df66ebf.svg";
export { ForwardRef as ReactComponent };